import React, { useEffect, useState, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { Col, Row, Button, Collapse, Container } from 'reactstrap';

import authorizedFetch from './api-authorization/AuthorizedFetch';
import BrainModel from './BrainModel';
import VoteSummary from './VoteSummary';
import ResponseLabel from './ResponseLabel';
import { DysregulatedResponseButton, DysregulatedStudentResponseForm } from './DysregulatedStudentForm';
import { safeParseResponse } from '../utils';

const AbsentButton = () => {
    return <Button size="sm">Absent</Button>;
}

const CheckInSummary = ({ checkInId: id }) => {
    const [ showResponses, setShowResponses ] = useState(false);
    const [ summaryData, setSummaryData ] = useState({});
    const [ dysregulationIsOpen, setDysregulationIsOpen] = useState(false);
    const [ selectedDysregulationResponse, setSelectedDysregulationResponse] = useState(null);

    const fetchData = useCallback(async () => {
        const response = await authorizedFetch(`api/check-ins/${id}/summary`);
        const summaryData = await safeParseResponse(response) || {};
        setSummaryData(summaryData);
    }, [id, setSummaryData]);

    const toggleResponses = () => setShowResponses(!showResponses);
    const toggleDysregulation = () => setDysregulationIsOpen(!dysregulationIsOpen);
    const onDysregulationSubmit = () => setDysregulationIsOpen(false);

    const openDysregulationResponse = (dysregulatedResponse) => {
        setSelectedDysregulationResponse(dysregulatedResponse);
        setDysregulationIsOpen(true);
    }

    useEffect(() => {
        fetchData();
        const reloadInterval = setInterval(fetchData, 5000);
        return () => {
            clearInterval(reloadInterval);
        }
    }, [fetchData]);

    const { availableActivities, classAverage, responses } = summaryData;

    return (
        <Container>
            <Row xs="1" sm="1" md="2" lg="2" xl="2">
                <Col>
                    <h6>Classroom State</h6>
                    <BrainModel value={classAverage} />
                    <VoteSummary activities={availableActivities} />
                </Col>
                <Col>
                    {responses &&
                        <>
                            <Collapse isOpen={showResponses}>
                                <Row>
                                    <Col>
                                        <h6>Responses: {responses.received} / {responses.expected}</h6>
                                        <h6>Dysregulated Students</h6>
                                        <ul>
                                            {responses.problematicResponses?.map((x, i) => 
                                                // change key to name? are all names different?
                                                <li key={i}>{x.userFullName} - <ResponseLabel response={x.value} />: {x.dysregulationActivity} <DysregulatedResponseButton response={x} onClick={openDysregulationResponse} /></li>
                                            )}
                                        </ul>
                                        <h6>Missing Responses</h6>
                                        <ul>
                                            {responses.missingStudents?.map(missingStudent =>
                                                // change key
                                                <li key={missingStudent.userId}>{missingStudent.userFullName} <AbsentButton userId={missingStudent.userId} /></li>
                                            )}
                                        </ul>
                                    </Col>
                                </Row>
                            </Collapse>
                            <Row style={{ justifyContent:'center' }}>
                                <Col>
                                    <Button color="primary" onClick={toggleResponses}>
                                        {showResponses ? "Hide Responses" : "Show Responses"}
                                    </Button>
                                </Col>
                            </Row>
                        </>
                    }
                </Col>
            </Row>
            <DysregulatedStudentResponseForm isOpen={dysregulationIsOpen} toggle={toggleDysregulation} onSubmitted={onDysregulationSubmit} response={selectedDysregulationResponse} />
        </Container>
    );
}

export const CheckInSummaryPage = () => {
    const params = useParams();
    console.log(params);
    return <CheckInSummary {...params} />;
}

export default CheckInSummary;